module.exports = __webpack_public_path__ + "static/media/service2.feb86e33.png";